// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/postback.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FindTestClickRequest, FindTestClickResponse, ListPostbacksRequest, ListPostbacksResponse, ListSourceEventsRequest, ListSourceEventsResponse, ListUnmappedStatusesRequest, ListUnmappedStatusesResponse, MapPostbackStatusRequest, MapPostbackStatusResponse, ReplayPostbacksRequest, ReplayPostbacksResponse, SendTestPostbackRequest, SendTestPostbackResponse } from "./postback_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.PostbackService
 */
export const PostbackService = {
  typeName: "tracker.v1.PostbackService",
  methods: {
    /**
     * @generated from rpc tracker.v1.PostbackService.ListPostbacks
     */
    listPostbacks: {
      name: "ListPostbacks",
      I: ListPostbacksRequest,
      O: ListPostbacksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.PostbackService.ReplayPostbacks
     */
    replayPostbacks: {
      name: "ReplayPostbacks",
      I: ReplayPostbacksRequest,
      O: ReplayPostbacksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.PostbackService.ListUnmappedStatuses
     */
    listUnmappedStatuses: {
      name: "ListUnmappedStatuses",
      I: ListUnmappedStatusesRequest,
      O: ListUnmappedStatusesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.PostbackService.MapPostbackStatus
     */
    mapPostbackStatus: {
      name: "MapPostbackStatus",
      I: MapPostbackStatusRequest,
      O: MapPostbackStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.PostbackService.FindTestClick
     */
    findTestClick: {
      name: "FindTestClick",
      I: FindTestClickRequest,
      O: FindTestClickResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.PostbackService.SendTestPostback
     */
    sendTestPostback: {
      name: "SendTestPostback",
      I: SendTestPostbackRequest,
      O: SendTestPostbackResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.PostbackService.ListSourceEvents
     */
    listSourceEvents: {
      name: "ListSourceEvents",
      I: ListSourceEventsRequest,
      O: ListSourceEventsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

